import { useContext, useEffect } from 'react';
import AddContext from './AddContext';
const AddModeForm = ({ children, ignoreAddMode = false }) => {
    const { setAddMode, resetAddMode } = useContext(AddContext);
    useEffect(() => {
        if (!ignoreAddMode) {
            setAddMode();
        }
        return () => {
            if (!ignoreAddMode) {
                resetAddMode();
            }
        };
    }, [ignoreAddMode, resetAddMode, setAddMode]);
    return children;
};
export default AddModeForm;
